(() => {
  function clerkSyncSetCookie(name, value) {
    const expires = new Date(Date.now() + 86400000).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }

  function clerkSyncGetCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return null;
  }

  function clerkSyncRemoveCookie(name) {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  function isMobileAppWrapper() {
    return navigator.userAgent.includes("FashionphileApp");
  }

  function getMobileAppVersion() {
    const version = (navigator.userAgent.match(/VersionName-([^;]+);/) || [])[1] || null;
    return version;
  }

  function logSentry(message, context, userId, tags) {
    // Temporarily turn off Sentry logging
    return;
    const cookies = document.cookie
      .split(";")
      .map((entry) => entry.trim())
      .filter((entry) => {
        const parts = entry.split("=");
        if (!parts[0]) {
          return false;
        }
        const name = parts[0].toLowerCase();
        return !name.includes("email") && !name.includes("token");
      })
      .reduce((result, entry) => {
        const parts = entry.split("=");
        const key = parts[0];
        const value = parts[1] || "";
        result[key] = value.substring(0, 15);
        return result;
      }, {});

    Sentry?.addBreadcrumb?.({
      category: "cookies",
      level: "info",
      message: "Filtered cookies",
      data: { cookies },
    });
    Sentry?.withScope?.((scope) => {
      if (tags) {
        Object.entries(tags).forEach(([key, value]) => {
          scope.setTag(key, String(value));
        });
      }
      scope.setUser({ id: String(userId) });
      scope.setTag("isMobileApp", String(isMobileAppWrapper()));
      scope.setTag("appVersion", String(getMobileAppVersion()));
      scope.setContext("Clerk", context);
      Sentry?.captureMessage?.(message, "error");
    });
  }

  function silentlySsoLoginShopify(clerkUserId) {
    let currentPath = window.location.pathname + window.location.search;
    if (currentPath.includes("sso=silent")) {
      logSentry(
        "Sync mismatch Shopify and Clerk (Signed in), url already has sso=silent",
        {
          clerkUserId: String(clerkUserId),
          status: String(Clerk?.status),
          client: String(Clerk?.client?.id),
        },
        clerkUserId,
      );
      return;
    }
    const separator = currentPath.includes("?") ? "&" : "?";
    const redirectUrl = `${currentPath}${separator}sso=silent`;

    logSentry(
      "Sync mismatch Shopify and Clerk (Signed in), Shopify sso signed in",
      {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      },
      clerkUserId,
    );

    clerkSyncSetCookie("syncShopifySsoCount", 1, 1);
    window.location.href = redirectUrl;
  }

  function silentlyLogoutForLoginShopify(baseLogoutUrl, clerkUserId) {
    const currentPath = window.location.pathname + window.location.search;
    const encodedReturnUrl = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLogoutUrl}?return_url=${encodedReturnUrl}`;

    logSentry(
      "Sync mismatch Shopify and Clerk (Signed in), Shopify silently signed out for sign in",
      {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      },
      clerkUserId,
    );
    clerkSyncSetCookie("syncShopifyLogoutForLoginCount", 1, 1);
    window.location.href = redirectUrl;
  }

  function silentlyAuthenticationLoginShopify(baseLoginUrl, clerkUserId) {
    let currentPath = window.location.pathname + window.location.search;
    if (!currentPath.includes("sso=silent")) {
      const separator = currentPath.includes("?") ? "&" : "?";
      currentPath += `${separator}sso=silent`;
    }
    const encodedReturnTo = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLoginUrl}?return_to=${encodedReturnTo}`;

    logSentry(
      "Sync mismatch Shopify and Clerk (Signed in), Shopify authentication signed in",
      {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      },
      clerkUserId,
    );

    clerkSyncSetCookie("syncShopifyAuthenticationCount", 1, 1);
    window.location.href = redirectUrl;
  }

  function silentlyLoginClerkSatellite(clerkUserId) {
    let currentPath = window.location.pathname + window.location.search;
    if (currentPath.includes("__clerk_synced=false")) {
      logSentry(
        "Sync mismatch Shopify (Signed in) and Clerk, url already has __clerk_synced=false",
        {
          customerId: String(customerId),
          status: String(Clerk?.status),
          client: String(Clerk?.client?.id),
        },
        customerId,
      );
      return;
    }
    const separator = currentPath.includes("?") ? "&" : "?";
    const redirectUrl = `${currentPath}${separator}__clerk_synced=false`;

    logSentry(
      "Sync mismatch Shopify and Clerk (Signed in), Shopify sso signed in",
      {
        customerId: String(customerId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      },
      customerId,
    );

    clerkSyncSetCookie("syncShopifySatelliteCount", 1, 1);
    window.location.href = redirectUrl;
  }

  async function silentlyLogoutClerk(webAppApiUrl, clerkUserId, syncShopifyClerkLogoutCount) {
    try {
      if (!isMobileAppWrapper()) {
        const token = await window.getSessionToken();
        if (token) {
          await fetch(`${webAppApiUrl}/auth/revoke-client-session`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ session_id: Clerk?.session?.id }),
          });
          window.flutter_inappwebview?.callHandler("authentication", { action: "clerk-silently-logged-out" });
        }
      }
    } finally {
      logSentry(
        "Sync mismatch Shopify and Clerk (Signed in), Clerk silently signed out",
        {
          clerkUserId: String(clerkUserId),
          status: String(Clerk?.status),
          client: String(Clerk?.client?.id),
          syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
        },
        clerkUserId,
      );
      clerkSyncSetCookie("syncShopifyClerkLogoutCount", syncShopifyClerkLogoutCount + 1, 1);
    }
  }

  function silentlyLogoutShopify(baseLogoutUrl, customerId) {
    const currentPath = window.location.pathname + window.location.search;
    const encodedReturnUrl = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLogoutUrl}?return_url=${encodedReturnUrl}`;

    logSentry(
      "Sync mismatch Shopify (Signed in) and Clerk, Shopify silently signed out",
      {
        customerId: String(customerId),
        status: String(Clerk?.status),
        session: String(Clerk?.session),
        isSignedIn: String(Clerk?.isSignedIn),
        client: String(Clerk?.client?.id),
      },
      customerId,
    );
    clerkSyncSetCookie("syncShopifyLogoutCount", 1, 1);
    window.location.href = redirectUrl;
  }

  async function syncSignIn(customerId, clerkUserId, baseLoginUrl, baseLogoutUrl, webAppApiUrl, isSatellite) {
    if (!!customerId !== !!clerkUserId) {
      if (clerkUserId) {
        const syncShopifySsoCount = parseInt(clerkSyncGetCookie("syncShopifySsoCount") || "0", 10);
        if (!syncShopifySsoCount) {
          silentlySsoLoginShopify(clerkUserId);
        } else {
          const syncShopifyLogoutForLoginCount = parseInt(
            clerkSyncGetCookie("syncShopifyLogoutForLoginCount") || "0",
            10,
          );
          if (!syncShopifyLogoutForLoginCount) {
            silentlyLogoutForLoginShopify(baseLogoutUrl, clerkUserId);
          } else {
            const syncShopifyAuthenticationCount = parseInt(
              clerkSyncGetCookie("syncShopifyAuthenticationCount") || "0",
              10,
            );
            if (!syncShopifyAuthenticationCount) {
              silentlyAuthenticationLoginShopify(baseLoginUrl, clerkUserId);
            } else {
              const syncShopifyClerkLogoutCount = parseInt(
                clerkSyncGetCookie("syncShopifyClerkLogoutCount") || "0",
                10,
              );
              if (!syncShopifyClerkLogoutCount) {
                clerkSyncSetCookie("syncShopifyClerkLogoutCount", 1, 1);
                logSentry(
                  "Sync mismatch Shopify and Clerk (Signed in), 1 recovery wait",
                  {
                    clerkUserId: String(clerkUserId),
                    status: String(Clerk?.status),
                    client: String(Clerk?.client?.id),
                    syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
                  },
                  clerkUserId,
                );
              } else if (syncShopifyClerkLogoutCount <= 1) {
                await silentlyLogoutClerk(webAppApiUrl, clerkUserId, syncShopifyClerkLogoutCount);
              } else {
                clerkSyncSetCookie("syncShopifyClerkLogoutCount", syncShopifyClerkLogoutCount + 1, 1);
                logSentry(
                  "Sync mismatch Shopify and Clerk (Signed in), Clerk recently signed out",
                  {
                    clerkUserId: String(clerkUserId),
                    status: String(Clerk?.status),
                    client: String(Clerk?.client?.id),
                    syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
                  },
                  clerkUserId,
                );
              }
            }
          }
        }
      } else if (isMobileAppWrapper()) {
        logSentry(
          "Sync mismatch Shopify (Signed in) and Clerk (mobile app wrapper), no action taken",
          {
            customerId: String(customerId),
            status: String(Clerk?.status),
            session: String(Clerk?.session),
            isSignedIn: String(Clerk?.isSignedIn),
            client: String(Clerk?.client?.id),
          },
          customerId,
        );
        window.flutter_inappwebview?.callHandler("authentication", {
          action: "sync-mismatch-shopify-signed-in",
          customerId,
        });
      } else {
        if (isSatellite) {
          const syncShopifySatelliteCount = parseInt(clerkSyncGetCookie("syncShopifySatelliteCount") || "0", 10);
          if (syncShopifySatelliteCount < 1) {
            silentlyLoginClerkSatellite(customerId);
            return;
          }
        }
        const syncShopifyLogoutCount = parseInt(clerkSyncGetCookie("syncShopifyLogoutCount") || "0", 10);
        if (!syncShopifyLogoutCount) {
          silentlyLogoutShopify(baseLogoutUrl, customerId);
        } else {
          clerkSyncSetCookie("syncShopifyLogoutCount", syncShopifyLogoutCount + 1, 1);
          logSentry(
            "Sync mismatch Shopify (Signed in) and Clerk, Shopify recently signed out",
            {
              customerId: String(customerId),
              status: String(Clerk?.status),
              session: String(Clerk?.session),
              isSignedIn: String(Clerk?.isSignedIn),
              client: String(Clerk?.client?.id),
              syncShopifyLogoutCount: syncShopifyLogoutCount + 1,
            },
            customerId,
          );
        }
      }
    } else {
      if (isSatellite) {
        const syncShopifySatelliteCount = parseInt(clerkSyncGetCookie("syncShopifySatelliteCount") || "0", 10);
        if (syncShopifySatelliteCount) {
          clerkSyncRemoveCookie("syncShopifySatelliteCount");
        }
      }
    }
  }

  window.syncSignIn = syncSignIn;
})();
